import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { fetchIsAdmin } from '../lib/supabase/topicReleasesSync';

/**
 * True when signed-in user has a row in core_admins.
 */
export function useIsAdmin() {
  const { userId, loading: authLoading } = useAuth();
  const [checked, setChecked] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (authLoading) return undefined;
    if (!userId) {
      setIsAdmin(false);
      setChecked(true);
      return undefined;
    }

    let cancelled = false;
    setChecked(false);
    fetchIsAdmin(userId)
      .then((ok) => {
        if (!cancelled) setIsAdmin(ok);
      })
      .finally(() => {
        if (!cancelled) setChecked(true);
      });

    return () => {
      cancelled = true;
    };
  }, [userId, authLoading]);

  return {
    isAdmin,
    loading: authLoading || (Boolean(userId) && !checked),
  };
}
